import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, ref, watch } from 'vue';
import {
  formatRussianPhoneMaskValue,
  normalizeRussianPhoneDigits,
} from '@/js/utils/initializePhoneMask';


export default /*@__PURE__*/_defineComponent({
  __name: 'form-phone-field',
  props: {
    modelValue: {},
    required: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;

const emit = __emit;

const phoneInputRef = ref<{ setSelectionRange: (start: number, end: number) => void } | null>(null);
const phoneDisplay = ref('');

const PHONE_ALLOWED_KEYS = new Set([
  'Backspace',
  'Delete',
  'Tab',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
  'Enter',
]);

watch(
  () => props.modelValue,
  (digits) => {
    if (!digits) {
      phoneDisplay.value = '';
      return;
    }
    phoneDisplay.value = formatRussianPhoneMaskValue(digits);
  },
  { immediate: true },
);

const restorePhoneCursor = (beforeCursorDigits: number) => {
  nextTick(() => {
    const afterValue = phoneDisplay.value;
    let pos = afterValue.length;
    let digitsCount = 0;

    for (let i = 0; i < afterValue.length; i++) {
      if (/\d/.test(afterValue[i]!)) digitsCount++;
      if (digitsCount === beforeCursorDigits) {
        pos = i + 1;
        break;
      }
    }

    pos = Math.min(pos, afterValue.length);
    phoneInputRef.value?.setSelectionRange(pos, pos);
  });
};

const applyPhoneValue = (originalValue: string, selectionStart: number) => {
  const beforeCursorDigits = originalValue.slice(0, selectionStart).replace(/\D/g, '').length;

  phoneDisplay.value = formatRussianPhoneMaskValue(originalValue);
  emit('update:modelValue', normalizeRussianPhoneDigits(originalValue));
  restorePhoneCursor(beforeCursorDigits);
};

const onPhoneInput = (e: Event) => {
  const input = e.target as HTMLInputElement;
  applyPhoneValue(input.value, input.selectionStart ?? 0);
};

const onPhoneKeydown = (e: KeyboardEvent) => {
  if (e.ctrlKey || e.metaKey || e.altKey) {
    return;
  }

  if (PHONE_ALLOWED_KEYS.has(e.key)) {
    return;
  }

  if (/^\d$/.test(e.key)) {
    return;
  }

  e.preventDefault();
};

const onPhonePaste = (e: ClipboardEvent) => {
  e.preventDefault();

  const input = e.target as HTMLInputElement;
  const pasted = e.clipboardData?.getData('text') ?? '';
  const selectionStart = input.selectionStart ?? 0;
  const selectionEnd = input.selectionEnd ?? selectionStart;
  const nextValue = `${input.value.slice(0, selectionStart)}${pasted}${input.value.slice(selectionEnd)}`;

  applyPhoneValue(nextValue, selectionStart);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createBlock(_component_a_form_item, {
    class: "form-phone-field stc-ant-field-skin",
    label: "Телефон",
    name: "phone",
    required: __props.required
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        ref_key: "phoneInputRef",
        ref: phoneInputRef,
        class: "form-phone-field__input",
        type: "tel",
        inputmode: "numeric",
        value: phoneDisplay.value,
        placeholder: "+7 (960) 512-32-16",
        onInput: onPhoneInput,
        onKeydown: onPhoneKeydown,
        onPaste: onPhonePaste
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["required"]))
}
}

})